var map = {
	"./index/notice_details": "bf27",
	"./index/notice_details.vue": "bf27",
	"./index/notice_list": "1dba",
	"./index/notice_list.vue": "1dba",
	"./login/agreement": "4df7",
	"./login/agreement.vue": "4df7",
	"./login/download": "6fe7",
	"./login/download.vue": "6fe7",
	"./login/login": "5df9",
	"./login/login.vue": "5df9",
	"./login/password": "970a",
	"./login/password.vue": "970a",
	"./login/register": "5d41",
	"./login/register.vue": "5d41",
	"./mine/buy_list": "f8c5",
	"./mine/buy_list.vue": "f8c5",
	"./mine/exchange": "6e5b",
	"./mine/exchange.vue": "6e5b",
	"./mine/lightning": "d94a",
	"./mine/lightning.vue": "d94a",
	"./mine/list": "4ba7",
	"./mine/list.vue": "4ba7",
	"./mine/mother_coin": "e8f0",
	"./mine/mother_coin.vue": "e8f0",
	"./mine/mother_coin_s": "0443",
	"./mine/mother_coin_s.vue": "0443",
	"./mine/recharge": "fd58",
	"./mine/recharge.vue": "fd58",
	"./mine/recharge_list": "2ba7",
	"./mine/recharge_list.vue": "2ba7",
	"./mine/rotation": "fa89",
	"./mine/rotation.vue": "fa89",
	"./mine/rotation_list": "e4be",
	"./mine/rotation_list.vue": "e4be",
	"./mine/share": "59a6",
	"./mine/share.vue": "59a6",
	"./mine/system": "0a6f",
	"./mine/system.vue": "0a6f",
	"./mine/usdt_coin": "161b",
	"./mine/usdt_coin.vue": "161b",
	"./mine/withdraw": "f6a2",
	"./mine/withdraw.vue": "f6a2",
	"./mine/withdraw_list": "1cff",
	"./mine/withdraw_list.vue": "1cff",
	"./spell/piecing": "8aed",
	"./spell/piecing.vue": "8aed",
	"./spell/spell_list": "af3a",
	"./spell/spell_list.vue": "af3a"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "b285";
module.exports = webpackAsyncContext;